import React, { createContext, useContext, useRef, useCallback } from 'react';
import usePublicBookingFlow from '../hooks/usePublicBookingFlow';

export const BookingFlowContext = createContext(null);

export const BookingFlowProvider = ({ slug, children }) => {
  const bookingFlow = usePublicBookingFlow(slug);

  // Refs that were previously in PublicBookingPage
  const bookingWorkflowRef = useRef(null);
  const servicesRef = useRef(null);
  const contactFormRef = useRef(null);

  // Destructure before useCallback so the dep array holds a stable function
  // reference from the hook, not the bookingFlow object (which is a fresh
  // literal every render and would defeat memoization for all context consumers).
  const { handleContinueBooking } = bookingFlow;

  // Continue wrapper — passes contactFormRef to the hook handler
  const onContinue = useCallback(() => {
    handleContinueBooking(contactFormRef);
  }, [handleContinueBooking]);

  const value = {
    ...bookingFlow,
    // Refs
    bookingWorkflowRef,
    servicesRef,
    contactFormRef,
    // Wrapped handler
    onContinue,
    // Slug (needed by AppointmentSetupStep for API calls)
    slug,
  };

  return (
    <BookingFlowContext.Provider value={value}>
      {children}
    </BookingFlowContext.Provider>
  );
};

export const useBookingFlow = () => {
  const context = useContext(BookingFlowContext);
  if (!context) {
    throw new Error('useBookingFlow must be used within a BookingFlowProvider');
  }
  return context;
};
